  <mat-form-field [style]="style === undefined? null : style" data-cy="validvalue-form-field">
    <mat-label *ngIf="vvlabel" data-cy="validvalue-label">{{vvlabel}}</mat-label>
    <mat-select type="string" [(ngModel)]="selectedValue" (ngModelChange)="onItemSelect($event)" [placeholder]="vvplaceholder" [disabled]="disabled" data-cy="validvalue-select">
      <mat-option *ngIf="showNoneOption" [value]="null" data-cy="validvalue-none-option">None</mat-option>
      <mat-option *ngFor="let vv of theValidValueList" [value]="vv[properyName]" data-cy="validvalue-option">{{vv.ItemDisplayValue}}</mat-option>
    </mat-select>
  </mat-form-field>
